import Plus from "../../../../../../../common/Plus";
import styles from "./styles.module.css";

const Item = ({
  data,
  goToLink,
  expandItem,
  setExpandItem,
  className = "",
}) => {
  const hasChild = data?.children?.length > 0;
  const expanded = data?.title === expandItem?.title;

  const toggleExpand = () => {
    if (expandItem?.title === data?.title) setExpandItem(null);
    else setExpandItem(data);
  };

  const renderSubItem = (item) => (
    <Item
      key={item.title}
      data={item}
      goToLink={goToLink}
      className={styles.subItem}
    />
  );

  const handleClick = (e) => {
    e.stopPropagation();
    if (hasChild) toggleExpand();
    else goToLink(data);
  };

  return (
    <>
      <button onClick={handleClick} className={`${styles.item} ${className}`}>
        <p className={styles.text}>{data.title}</p>
        {hasChild && <Plus />}
      </button>
      {expanded && data.children.map(renderSubItem)}
    </>
  );
};

export default Item;
